/**
 * Action Types for all modules
 */


export const USER_INIT = 'user/INIT the user';
export const USER_LOG_IN = 'user/LOG IN the user';
export const USER_LOG_OUT = 'user/LOG OUT the user';
export const USER_CHECK = 'user/CHECK the user session';
export const USER_UPDATE_USER = 'user/UPDATE user info';
export const USER_HANDLE_ERROR = 'user/HANDLE ERROR';
export const USER_CLEAR_USER = 'user/CLEAR user';

export const SUBMISSION_GET_USER_SUBMISSION = 'submission/CHECK for a user submission';
export const SUBMISSION_MAKE_SUBMISSION = 'submission/MAKE user submission';
export const SUBMISSION_SUCCESS = 'submission/SUCCESS handle submission success';
export const SUBMISSION_CLEAR_ERROR = 'submission/CLEAR ERRORS';
export const SUBMISSION_CANCEL = 'submission/CANCEL submission calls';
export const SUBMISSION_CLEAR = 'submission/CLEAR submission';
export const SUBMISSION_HANDLE_ERROR = 'submission/HANDLE ERROR';
export const SUBMISSION_HANDLE_PROGRESS = 'submission/HANDLE progress update';

export const SUBMISSION_VIEW_RESET_ACTIVE_SUBMISSION = 'submissionView/RESET the active submission to the first submission if unset';
export const SUBMISSION_VIEW_HANDLE_SUBMISSION_FOUND = 'submissionView/HANDLE specified submission when found';
export const SUBMISSION_VIEW_HANDLE_SUBMISSIONS = 'submissionView/HANDLE submissions loaded';
export const SUBMISSION_VIEW_HANDLE_SUBMISSION_NOT_FOUND = 'submissionView/HANDLE specified submission when NOT found';
export const SUBMISSION_VIEW_STEP_SUBMISSION = 'submissionView/STEP to the prev / next submission';
export const SUBMISSION_VIEW_STEP_PAGE = 'submissionView/STEP to the prev/ next submission';
export const SUBMISSION_VIEW_GET_SUBMISSIONS = 'submissionView/GET submissions from the BE';
export const SUBMISSION_VIEW_GET_SUBMISSION = 'submissionView/GET this submission from the BE';
export const SUBMISSION_VIEW_SUCCESS = 'submissionView/SUCCESS handle fetch submission view success';
export const SUBMISSION_VIEW_CLEAR_ERROR = 'submissionView/CLEAR fetch ERRORS';
export const SUBMISSION_VIEW_CANCEL = 'submissionView/CANCEL submission view calls';
export const SUBMISSION_VIEW_CLEAR = 'submissionView/CLEAR fetched submissions';
export const SUBMISSION_VIEW_HANDLE_ERROR = 'submissionView/HANDLE ERROR';
export const SUBMISSION_VIEW_REPORT_SUBMISSION = 'submissionView/REPORT submission';
export const SUBMISSION_VIEW_UPDATE_SUBMISSION_PARAM = 'submissionView/UPDATE the submission GET param';
